import React, {useEffect} from "react";
import {Col, Form, Row, Button, ButtonGroup } from "react-bootstrap";
import { MdLockPerson } from "react-icons/md";
import { useForms } from "./../../use-forms/index"
import { z } from "zod"

const formSchema = z.object({
    email: z.string().email("É permitido somente e-mail válido."),
  referral_code: z.string()
    .nonempty("Código de indicação é obrigatório.")
    .default('Linkt-sigmobi'), //@to-do set defalult code value
  password: z.string()
    .nonempty("Senha é obrigatório.")
    .min(6, "Senha deve conter 6 caracteres.")
    .max(6, "Senha deve conter 6 caracteres."),
  confirm_password: z.string()
    .min(6, "Confirmar senha deve conter 6 caracteres.")
    .max(6, "Confirmar senha deve conter 6 caracteres.")
    .nonempty("Confirmação de senha é obrigatório.")
})

//Form step 3
function Index(props) {
  const {
    register,
    setValue,
    setError,
    clearErrors,
    handleSubmit,
    formState: { errors },
  } = useForms({ validator: formSchema })

  useEffect(() => {
    clearErrors()
    setValue('email', props.form.email)
    setValue('password', props.form.password)
    setValue('confirm_password', props.form.confirm_password)
    setValue('referral_code', props.form.referral_code)
  }, [])

  const onSubmitForm = data => {
    //post or validate data to/on api endpoint here

    if (data.password !== data.confirm_password) {
      return setError('confirm_password', {message: 'O valor do campo "confirmar senha" deve ser o mesmo que o valor do campo "Senha"'})
    }

    //on success
    props?.submit(data)
  }

  return (
    <Form onSubmit={handleSubmit(onSubmitForm)} className="col-12 col-md-6 col-lg-4">
      <div className="background"></div>
      <h2 className="mb-3"><MdLockPerson/> Acesso</h2>
      <p>Preencha os campos correspondentes às suas informações de Acesso, e salve para continuar.</p>
      <Col>
        <Form.Group hidden={true} as={Col} className="mb-3 col-12">
          <Form.Label column sm="6">
            Código de indicação
          </Form.Label>
          <Col sm="12">
            <Form.Control className="mb-3" {...register('referral_code')} />
            {errors.referral_code?.message && <div className="text-danger">{errors.referral_code?.message}</div>}
          </Col>
        </Form.Group>

        <Row>
        <Col sm="12">
          <Form.Group as={Col} className="mb-3 col-12">
            <Form.Label column sm="5">
              Email
            </Form.Label>
              <div>
              <Form.Control className="mb-3" {...register('email')} />
              {errors.email?.message && <div className="text-danger">{errors.email?.message}</div>}
              </div>
          </Form.Group>
          </Col>
          
          <Form.Group
            as={Col}
            className="mb-3"
          >
            <Form.Label column sm="5">
              Senha
            </Form.Label>
            <Col sm="12">
              <Form.Control type="password" placeholder="Password" {...register('password')} />
              {errors.password?.message && <div className="text-danger">{errors.password?.message}</div>}
            </Col>
          </Form.Group>

          <Form.Group as={Col} className="mb-3 col-12">
            <Form.Label column sm="5">
              Confirmar a Senha
            </Form.Label>
            <Col sm="12">
              <Form.Control type="password" placeholder="Password" {...register('confirm_password')} />
              {errors.confirm_password?.message && <div className="text-danger">{errors.confirm_password?.message}</div>}
            </Col>
          </Form.Group>
        </Row>

        <ButtonGroup className="col-12 mt-5">
          <Button onClick={props?.back} className="btn btn-light btn-large" type="button">Voltar</Button>
          <Button className="btn btn-primary btn-large centerButton" type="submit">Salvar</Button>
        </ButtonGroup>
      </Col>
    </Form>
  );
}

export default Index;
